interface WindSubSimulationParams {
  meshDistance?: number | string | null;
  [key: string]: unknown;
}

interface WindSubSimulation {
  simType?: string;
  params?: WindSubSimulationParams;
  [key: string]: unknown;
}

const normalizeWindMeshDistanceByLength2 = <T extends WindSubSimulation>(
  subSimulations: T[],
  length2: number | string
): T[] => {
  if (!Array.isArray(subSimulations) || subSimulations.length === 0) return subSimulations;

  const numericLength2 = Number(length2);
  if (!Number.isFinite(numericLength2)) return subSimulations;
  const defaultMeshDistance = numericLength2 + 100;

  return subSimulations.map((subSim) => {
    if (subSim?.simType !== 'WIND') return subSim;

    const rawMeshDistance = subSim?.params?.meshDistance;
    const meshDistance = rawMeshDistance === '' || rawMeshDistance == null ? NaN : Number(rawMeshDistance);
    const nextMeshDistance = Number.isFinite(meshDistance) ? meshDistance : defaultMeshDistance;

    if (subSim?.params?.meshDistance === nextMeshDistance) return subSim;

    return {
      ...subSim,
      params: {
        ...subSim.params,
        meshDistance: nextMeshDistance,
      },
    };
  });
};

export { normalizeWindMeshDistanceByLength2 };
